import { db } from 'config'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { v4 as uuidv4 } from 'uuid'

const trackerEntriesExpensesCollectionRef = collection(db, 'tracker_entries')

export const getActualsExpenseEntry = async (
  trackerId,
  month,
  expenseCategory,
  trackerEntries
) => {
  const data = await trackerEntries
  const filteredData = data?.filter(
    (t) =>
      t.data.trackerId === trackerId &&
      t.data.month === month &&
      t.data.name === expenseCategory &&
      t.data.actual === true &&
      t.data.type === 'Expense'
  )

  if (filteredData.length > 0) {
    return {
      id: filteredData[0].id,
      month: month,
      data: filteredData[0].data
    }
  } else {
    return {
      id: uuidv4(),
      month: month,
      data: null
    }
  }
}
